import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import { SignalStep } from '../signal-step'
import './style.scss'

export function ModemAlmostDone() {
  const dispatch = useDispatch()

  function handleNextClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.MODEM_FINISH))
  }

  return (
    <div className='modem-almost-done'>
      <SignalInfo
        icon={STATICS.MODEM_RESTART}
        iconAlt='Icone de modem reiniciando'
        title='Estamos quase lá...'
      >
        <SignalStep
          number={4}
          description='Aguarde até que a luz da internet fique acesa constantemente, sem piscar.'
        />
      </SignalInfo>
      <div className='actions-container'>
        <Button className='button-component -large' color='primary' onClick={handleNextClick}>
          As luzes estão acesas
        </Button>
      </div>
    </div>
  )
}
